import { useMemo, useCallback, useState } from 'react';
import ReorderActivityButtonsSelect from './ReorderActivityButtonsSelect';
import { getTranslatedButtonAction } from '../helpers/buttonTranslations';
import { getButtonIcon } from '../helpers/buttonIcons';
import { jsx as _jsx } from "react/jsx-runtime";
const NUM_OF_SELECTS = 5;
const EMPTY_SELECT_PREFIX = 'empty-select';
const DEFAULT_FOCUS_POSITION = 0;
const ReorderActivityButtonsSelects = ({
  allActivityButtons,
  indicesOfDuplicates,
  orderedSelectedActivityButtons,
  onSelectedActivitiesChange,
  shouldShowErrors
}) => {
  const [focusInteractionIndex, setFocusInteractionIndex] = useState(DEFAULT_FOCUS_POSITION);

  // add empty selects to render if there are less than five
  // activities already selected
  const orderedSelectsToRender = useMemo(() => {
    const _orderedSelectsToRender = [];
    for (let i = 0; i < NUM_OF_SELECTS; i++) {
      _orderedSelectsToRender.push(orderedSelectedActivityButtons[i] || `${EMPTY_SELECT_PREFIX}-${i + 1}`);
    }
    return _orderedSelectsToRender;
  }, [orderedSelectedActivityButtons]);
  const handleSelectChange = useCallback((newSelection, index, previousSelection) => {
    onSelectedActivitiesChange(newSelection, index, previousSelection);
    setFocusInteractionIndex(index);
  }, [onSelectedActivitiesChange]);
  const allAvailableActivityTypeOptions = useMemo(() => allActivityButtons.map(option => ({
    text: getTranslatedButtonAction(option),
    value: option,
    icon: getButtonIcon(option),
    iconColor: 'icon-core-default'
  })), [allActivityButtons]);
  const selects = useMemo(() => {
    return orderedSelectsToRender.map((activityType, index) => {
      const isEmpty = activityType.includes(EMPTY_SELECT_PREFIX);
      const shouldShowError = shouldShowErrors && indicesOfDuplicates.has(activityType) && indicesOfDuplicates.get(activityType).has(index) && indicesOfDuplicates.get(activityType).size > 1;
      return /*#__PURE__*/_jsx(ReorderActivityButtonsSelect, {
        allActivityButtonsOptions: allAvailableActivityTypeOptions,
        error: shouldShowError,
        index: index,
        onSelectChange: handleSelectChange,
        selectedActivityType: isEmpty ? '' : activityType,
        focusInteractionIndex: focusInteractionIndex
      }, isEmpty ? activityType : `${activityType}-${index}`);
    });
  }, [orderedSelectsToRender, shouldShowErrors, indicesOfDuplicates, allAvailableActivityTypeOptions, handleSelectChange, focusInteractionIndex]);
  return /*#__PURE__*/_jsx("div", {
    children: selects
  });
};
export default ReorderActivityButtonsSelects;